import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

const Projects = lazy(() => import('./Projects'));
const ProjectDetails = lazy(() => import('./project/ProjectDetails'));
const ProjectViews = lazy(() => import('./project/ProjectViews'));
const ProjectsReport = lazy(() => import('./ProjectsReport'));
const ProjectsDashboard = lazy(() => import('./ProjectsDashboard'));

const ProjectsAppConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: 'apps/projects',
      element: <Outlet />,
      children: [
        { index: true, element: <Projects /> },
        {
          path: ':projectId',
          element: <ProjectDetails />,
          children: [
            { path: ':view', element: <ProjectViews /> },
            { path: ':view/:taskId', element: <ProjectViews /> },
            { path: ':view/:taskId/:mode', element: <ProjectViews /> },
          ],
        },
      ],
    },
    {
      path: 'apps/projects-report',
      element: <ProjectsReport />,
    },
    {
      path: 'apps/projects-dashboard',
      element: <ProjectsDashboard />,
    },
  ],
};

export default ProjectsAppConfig;
